import List from 'components/List.jsx';
import React from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import Text from 'components/Text.jsx';

import createChainedFunction from 'utils/createChainedFunction';
import cx from 'classnames';

import styles from './styles/TabView.css';

export default class TabView extends React.Component {
  static propTypes = {
    viewRenderer: React.PropTypes.func,
    tabListRenderer: React.PropTypes.func,
    tabRenderer: React.PropTypes.func,
  };

  static defaultProps = {
    viewRenderer: ({ tabList, panel, ...props }) => (
      <div {...props}>
        {tabList}
        {panel}
      </div>
    ),
    tabListRenderer: ({ tabs, ...props }) => <List {...props}>{tabs}</List>,
    tabRenderer: ({ panel, selected, ...props }) => (
      <Text {...props} weight={selected ? 'bold' : null}>
        {panel.props.name}
      </Text>
    ),
  };

  constructor(props, context) {
    super(props, context);

    const panels = React.Children.toArray(props.children);
    const selectedPanelIndex = panels.findIndex(panel => panel.props.defaultSelected);

    this.state = {
      selectedPanelIndex: selectedPanelIndex >= 0 ? selectedPanelIndex : 0,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    const {
      viewRenderer,
      tabListRenderer,
      tabRenderer,
      children,
      ...props
    } = this.props;

    const { selectedPanelIndex } = this.state;
    const panels = React.Children.toArray(children);

    const tabList = tabListRenderer({
      tabs: panels.map((panel, index) => {
        const tab = tabRenderer({
          panel,
          selected: index === selectedPanelIndex,
        });

        return React.cloneElement(tab, {
          key: index,
          className: cx(tab.props.className, styles.tab),
          onClick: createChainedFunction(
            () => {
              if (index !== this.state.selectedPanelIndex) {
                this.setState({ selectedPanelIndex: index });
              }
            },
            tab.props.onClick
          ),
        });
      }),
    });

    return viewRenderer(Object.assign(props, {
      tabList,
      panel: panels[selectedPanelIndex],
    }));
  }
}

export class Panel extends React.Component {
  static propTypes = {
    name: React.PropTypes.string.isRequired,
    defaultSelected: React.PropTypes.bool,
    children: React.PropTypes.node.isRequired,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    const {
      name,  // eslint-disable-line no-unused-vars
      children,
      ...props
    } = this.props;
    return <div {...props}>{children}</div>;
  }
}

TabView.Panel = Panel;



// WEBPACK FOOTER //
// ./src/components/TabView.jsx